import actionTypes from './GCMOMCRU05ActionType';

/**
 * 組織情報(プロフィール)監理団体
 */
const initialState = {
    isFetching: false,
    data: [],
    isError: false,
    err_type: "",
    err_detail: []
};

/**
 * 組織情報(プロフィール)監理団体取得するReducer
 * @param {*} state
 * @param {*} action
 */
export const getSupervisingOrgInfo = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_SUPERVISING_ORG_INFO_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.GET_SUPERVISING_ORG_INFO_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.GET_SUPERVISING_ORG_INFO_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.GET_SUPERVISING_ORG_INFO_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};

/**
 * 組織情報(プロフィール)監理団体を更新するReducer
 * @param {*} state
 * @param {*} action
 */
export const updateSupervisingOrgInfo = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_SUPERVISING_ORG_INFO_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.UPDATE_SUPERVISING_ORG_INFO_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.UPDATE_SUPERVISING_ORG_INFO_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.UPDATE_SUPERVISING_ORG_INFO_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};
